import { Components, Theme } from '@mui/material'

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  variants: [
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => ({
        borderColor: theme.palette.divider,
      }),
    },
  ],
}
